import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  OTP_GENERATE_SUCCESS,
  OTP_VERIFY_SUCCESS,
  OTP_ACTION_ERROR,
  CLEAR_LOGIN_MESSAGE,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  mssg: "",
  userData: null,
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        loading: true,
        mssg: "",
      }
    
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        mssg: "",
      }
    
    case OTP_GENERATE_SUCCESS:
      return {
        ...state,
        loading: false,
        mssg: action.payload,
        error: "",
      }
    
    case OTP_VERIFY_SUCCESS:
      return {
        ...state,
        loading: false,
        mssg: action.payload.message,
        userData: action.payload.userData,
        error: "",
      }
    
    case OTP_ACTION_ERROR:
      return {
        ...state,
        loading: false,
        mssg: action.payload,
        error: action.payload,
      }
    
    case CLEAR_LOGIN_MESSAGE:
      return {
        ...state,
        mssg: "",
        error: "",
      }
    
    case LOGOUT_USER:
      return { ...state }
    
    case LOGOUT_USER_SUCCESS:
      return { ...state }
    
    case API_ERROR:
      return { 
        ...state, 
        error: action.payload, 
        mssg: action.payload,
        loading: false 
      }
    
    default:
      return state
  }
}

export default login